// @generated by TypeGen from LogbookModel/AccountUser.swift - DO NOT EDIT

export interface IAccountUser {
  accountId: number;
  userId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  accountLevel: IAccountUserLevel;
  permissions: string;
}

export enum IAccountUserLevel {
  disabled = 0,
  user = 1,
  admin = 100,
}
